import { LinearProgress as MaterialProgress } from '@mui/material'

const LinearProgress = MaterialProgress

export { LinearProgress }
